import { DatePicker } from 'antd';
import React, { useState } from 'react';
import * as intl from 'react-intl-universal';
import moment from 'moment';
import { languages } from 'common/i18n';

type CUSTOM = 'LONGTERM';

const costomIntl: { [key in CUSTOM]: string } = {
    'LONGTERM': intl.get('SignUp.LongTermEffective').d('长期有效')
};

function Index(props: any) {
    const { disabled, value, onChange, staticView, customKey, dropdownClassName, size, showTime, disabledDate, disabledTime, showNow,
        showToday = false, format = 'YYYY-MM-DD'
    } = props;

    const [pickerOpen, setPickerOpene] = useState<boolean>(false);
    const customText = costomIntl[customKey as CUSTOM];
    const customValue = costomIntl[value as CUSTOM];

    if (staticView && disabled) {
        return value ? (customValue || value) : '-';
    }

    // 自定义值处理
    const customHandle = () => {
        onChange(customKey);
        setPickerOpene(false);
    };

    // 配置国际化语言(moment的locale未正确设置会导致部分语言错乱)
    moment.locale(languages.getLocale());
    const timeValue = value ? (value === customKey ? moment() : moment(value)) : value;
    return (
        <DatePicker
            id={props.id}
            {...{
                ...(customText ? {
                    renderExtraFooter: () => <p style={{ textAlign: 'center', cursor: 'pointer' }} onClick={customHandle}>{customText}</p>
                } : {}),
                ...(customValue ? {
                    open: pickerOpen,
                } : {}),
            }}
            defaultValue={timeValue}
            value={timeValue}
            disabled={disabled}
            size={size}
            showToday={showToday}
            showNow={showNow}
            showTime={showTime}
            disabledDate={disabledDate}
            dropdownClassName={dropdownClassName}
            placeholder={intl.get('Hint.Select', { field: intl.get('Global.Date') })}
            disabledTime={disabledTime && value && moment(value).date() == moment().date() ? disabledTime : () => {
                return {
                    disabledHours: (): any => [],
                    disabledMinutes: (): any => [],
                    disabledSeconds: (): any => []
                };
            }}
            format={(value) => customValue || value.format(format)}
            onChange={(date: any) => {
                onChange(date && date.format(format));
            }}
            onOpenChange={setPickerOpene} />
    );
}

export default Index;
